import styled from "styled-components";
import { Button } from "@/react/styled";
import PlusSmallIcon from "@8x8/oxygen-icon/icons/PlusSmallIcon";
import { COLORS } from "@/react/theme/constants";
import { ButtonGroup } from "@8x8/oxygen-button";

export const StyledButton = styled(Button)`
  padding: 0;
  display: flex;
  align-items: center;
`;

export const StyledPlusIcon = styled(PlusSmallIcon)`
  fill: currentColor;
`;

export const Label = styled.div`
  color: ${COLORS.primary};
  font-style: ${(props) => (props.disabled ? "italic" : "normal")};
`;

export const IpBoxHeader = styled.div`
  grid-column: span 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const FieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const FieldGroupContainer = styled.div`
  margin-top: ${({ marginTop }) => marginTop || "16px"};
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
`;

export const StyledButtonGroup = styled(ButtonGroup)`
  margin-top: 20px;
  margin-bottom: 40px;
`;

export const FormContainer = styled.div`
  padding: 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ErrorText = styled.p`
  color: ${COLORS.danger};
`;
